import { ActivityTip } from './types';
import { ACTIVITY_DETAILS_COLORS, ACTIVITY_DETAILS_TYPOGRAPHY } from './constants';

interface TipItemProps {
  tip: ActivityTip;
}

/**
 * TipItem Component
 * 
 * Individual tip list item with bullet point.
 * Responsive: Text scales 16px → 18px → 20px.
 */
export default function TipItem({ tip }: TipItemProps) {
  // Helper to render text with bold keywords
  const renderTipText = (text: string) => {
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, index) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        const boldText = part.slice(2, -2);
        return (
          <strong
            key={index}
            className="font-semibold"
            style={{
              color: ACTIVITY_DETAILS_COLORS.textBody,
            }}
          >
            {boldText}
          </strong>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <li
      className={`${ACTIVITY_DETAILS_TYPOGRAPHY.body.weight} ${ACTIVITY_DETAILS_TYPOGRAPHY.body.sizeClasses} ${ACTIVITY_DETAILS_TYPOGRAPHY.body.leading}`}
      style={{
        fontFamily: 'DM Sans, sans-serif',
        color: ACTIVITY_DETAILS_COLORS.textBody,
      }}
    >
      {renderTipText(tip.text)}
    </li>
  );
}
